import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Journal() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles")
      .then((r) => setArticles(r.data || []))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="journal-page" className="pt-32 pb-20 px-6 md:px-12">
      <Seo
        title="Journal · Press & Dispatches"
        description="Selected features, op-eds, and announcements from the Office of Miguel Santana — press from Forbes, GQ, The New York Times, Bloomberg, and more."
        path="/journal"
        type="article"
      />
      <div className="max-w-[1440px] mx-auto">
        <p className="font-overline text-champagne mb-6">— The Journal</p>
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-silver leading-[0.95] tracking-tighter max-w-5xl">
          Press, profiles<br />
          <span className="italic font-light">and dispatches.</span>
        </h1>
        <p className="mt-12 max-w-2xl font-body text-silver-muted text-lg">
          Selected features, op-eds, and announcements from the Office of Miguel Santana.
        </p>

        <div className="mt-20 border-t hairline">
          {loading && (
            <p data-testid="journal-loading" className="py-12 font-body text-silver-muted">Loading dispatches…</p>
          )}
          {!loading && articles.length === 0 && (
            <p data-testid="journal-empty" className="py-12 font-body text-silver-muted">
              No articles published yet. Check back soon.
            </p>
          )}
          {!loading && articles.map((a, i) => (
            <Link
              key={a.id}
              to={`/journal/${a.slug || a.id}`}
              data-testid={`journal-item-${a.slug || a.id}`}
              className="group grid grid-cols-12 gap-6 items-center py-10 border-b hairline hover:bg-white/[0.025] transition-colors duration-300 px-2"
            >
              <div className="col-span-12 md:col-span-2">
                <p className="font-overline text-silver-muted">{String(i + 1).padStart(2, "0")}</p>
                <p className="font-overline text-champagne mt-2">{a.publication || "Editorial"}</p>
              </div>
              <div className="col-span-12 md:col-span-8">
                <h2 className="font-display text-2xl md:text-4xl text-silver leading-[1.1] tracking-tight group-hover:text-champagne transition-colors duration-300">
                  {a.title}
                </h2>
                <p className="mt-3 font-body text-silver-muted text-base line-clamp-2 max-w-2xl">
                  {a.excerpt}
                </p>
              </div>
              <div className="col-span-12 md:col-span-2 text-left md:text-right">
                <span className="font-overline text-silver group-hover:text-champagne transition-colors">Read →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
